import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const ContactsPageRouter: CustomRouteObject = {
  path: routeNamesPaths.contacts,
  lazy: async () => {
    const { ContactsPage } = await import('./ui')

    return {
      Component: ContactsPage,
    }
  },
  nodeRef: createRef(),
}
